<template>
    <div>
        <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                               :titleLabel="$t('profile.label.representatives_name')"
                               :parentScreen="parentScreen">
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="repLastName">{{$t('profile.label.last_name')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.repLastName'].$model"
                           id="repLastName"
                           name="repLastName"
                           required
                           maxlength="41"
                           v-convert-halfwidth-to-fullwidth>
                    <div v-if="$v.input['amsCustomerDetail.repLastName'].$error || $v.input['amsCustomerDetail.repLastName'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.repLastName'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.last_name')})}}
                        </div>
                        <div v-if="$v.input['amsCustomerDetail.repLastName'].required && !$v.input['amsCustomerDetail.repLastName'].maxLength">
                            {{ $t('MSG_TRS_NAF_0120', {param1 : $t('profile.label.last_name')})}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label"
                       for="repFirstName">{{$t('profile.label.first_name')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.repFirstName'].$model"
                           id="repFirstName"
                           name="repFirstName"
                           required
                           maxlength="41"
                           v-convert-halfwidth-to-fullwidth>
                    <div v-if="$v.input['amsCustomerDetail.repFirstName'].$error || $v.input['amsCustomerDetail.repFirstName'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.repFirstName'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.first_name')}) }}
                        </div>
                        <div v-if="$v.input['amsCustomerDetail.repFirstName'].required && !$v.input['amsCustomerDetail.repFirstName'].maxLength">
                            {{ $t('MSG_TRS_NAF_0120', {param1 : $t('profile.label.first_name')})}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="repLastNameKana">{{$t('profile.label.last_name_kana')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.repLastNameKana'].$model"
                           id="repLastNameKana"
                           name="repLastNameKana"
                           required
                           maxlength="41"
                           v-special-characters-validator
                           v-convert-kana-word
                    >
                    <div v-if="$v.input['amsCustomerDetail.repLastNameKana'].$error || $v.input['amsCustomerDetail.repLastNameKana'].$anyError"
                         class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.repLastNameKana'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.last_name_kana')}) }}
                        </div>
                        <div v-if="$v.input['amsCustomerDetail.repLastNameKana'].required && !$v.input['amsCustomerDetail.repLastNameKana'].maxLength">
                            {{ $t('MSG_TRS_NAF_0120', {param1 : $t('profile.label.last_name_kana')})}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label" for="repFirstNameKana">{{$t('profile.label.first_name_kana')}}</label>
                <div class="col-md-6">
                    <input type="text" class="form-control"
                           v-model="$v.input['amsCustomerDetail.repFirstNameKana'].$model"
                           id="repFirstNameKana"
                           name="repFirstNameKana"
                           required
                           maxlength="41"
                           v-special-characters-validator
                           v-convert-kana-word
                    >
                    <div v-if="$v.input['amsCustomerDetail.repFirstNameKana'].$error || $v.input['amsCustomerDetail.repFirstNameKana'].$anyError" class="error-messages ng-active">
                        <div v-if="!$v.input['amsCustomerDetail.repFirstNameKana'].required">
                            {{ $t('MSG_TRS_NAF_0004_param', {param1 : $t('profile.label.first_name_kana')}) }}
                        </div>
                        <div v-if="$v.input['amsCustomerDetail.repFirstNameKana'].required && !$v.input['amsCustomerDetail.repFirstNameKana'].maxLength">
                            {{ $t('MSG_TRS_NAF_0120', {param1 : $t('profile.label.first_name_kana')})}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="control-label col-md-3 col-form-label">{{$t('profile.label.upload.title')}}</label>
                <div class="col-md-6">
                    <FileInput v-model="$v.fileCustomerRepName1.$model" name="fileCustomerRepName1"></FileInput>
                    <error-messages-block :field="$v.fileCustomerRepName1">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerRepName2.$model" name="fileCustomerRepName2"></FileInput>
                    <error-messages-block :field="$v.fileCustomerRepName2">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 offset-md-3">
                    <FileInput v-model="$v.fileCustomerRepName3.$model" name="fileCustomerRepName3"></FileInput>
                    <error-messages-block :field="$v.fileCustomerRepName3">
                        <template #fileTypeValidation>
                            {{$t('profile.error.file_type',{param1 : fileTypeExtension})}}
                        </template>
                        <template #fileSizeValidation>
                            {{$t('profile.error.file_size')}}
                        </template>
                        <template #fileCustomerNameDuplicateValidation>
                            {{$t('profile.error.file_duplicate')}}
                        </template>
                    </error-messages-block>
                </div>
            </div>
            <div class="form-group row">
                <div class= "col-md-12">
                    <div class="alert alert-warning">
                        <div>
                            {{$t('profile.rep.after_upload')}}
                            <a :href="SUPPORT_DOCUMENT_URL" target="_blank">{{$t('profile.require.document')}}</a>
                            {{$t('profile.rep.after_upload_footer')}}
                        </div>
                        {{$t('profile.rep.after_upload2')}}
                    </div>
                </div>
            </div>
            <template v-if="this.isParentScreenEditProfile">
                <div class="form-action">
                    <button class="btn btn-sm btn-submit btn-success mr-2"
                            :disabled="isDisabledButtonSubmit && isInvalidFile"
                            :type="this.getButtonType()">
                        {{$t('profile.button.verify')}}
                    </button>
                    <button class="btn btn-default btn-cancel btn-sm"
                            type="button"
                            @click="reverseInput">
                        {{$t('profile.button.cancel')}}
                    </button>
                </div>
            </template>
        </ForceNewsBlockWrapper>
    </div>
</template>

<script>
/**
 * @author HungNS
 */
import {maxLength, required} from 'vuelidate/lib/validators'
import formMixin from '@/common/mixins/form';

export default {
        name: "UpdateCustomerRepName",
        props: {},
        mixins: [formMixin],
        data: function () {
            return {
                fileCustomerRepName1: null,
                fileCustomerRepName2: null,
                fileCustomerRepName3: null,
            }
        },
        computed: {
            SUPPORT_DOCUMENT_URL() {
                return this.$store.state[this.namespace].SUPPORT_DOCUMENT_URL
            },
            fileUploadExt() {
                return this.$store.state.header.headerInfo.fileUploadExt
            },
            fileTypeExtension() {
                return this.fileUploadExt.toUpperCase();
            },
            isInvalidFile(){
              const {$v} = this;
              return $v.$anyError || (this.fileCustomerRepName1 === null && this.fileCustomerRepName2 === null && this.fileCustomerRepName3 === null);
            },
        },
        validations() {
            const initValidData = this.getInitFileValidation({...this.$data},[], undefined, true);
            return {
                input: {
                    'amsCustomerDetail.repFirstName': {
                        required,
                        maxLength: maxLength(41)
                    },
                    'amsCustomerDetail.repFirstNameKana': {
                        required,
                        maxLength: maxLength(41)
                    },
                    'amsCustomerDetail.repLastName': {
                        required,
                        maxLength: maxLength(41)

                    },
                    'amsCustomerDetail.repLastNameKana': {
                        required,
                        maxLength: maxLength(41)
                    },
                },
                ...initValidData
            }

        },
        methods: {},
        mounted() {
        }

    }
</script>
<style scoped>
    .form-group {
        margin-bottom: 5px;
        padding-bottom: 15px;
    }
</style>

